import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params, Router} from "@angular/router";
import {MeasureModel} from "../../model/measure.model";
import {MeasureService} from "../measure.service";
import {UnitModel} from "../../model/unit.model";
import {UnitsService} from "../../units/units.service";

@Component({
    selector: 'app-measure-edit',
    templateUrl: './measure-edit.component.html',
    standalone: false
})
export class MeasureEditComponent implements OnInit {

  units: UnitModel[] = [];
  item: MeasureModel;

  constructor(
    private service: MeasureService,
    private unitService: UnitsService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }


  ngOnInit(): void {
    this.initPage();
  }

  initPage() {
    this.route.params.subscribe((params:Params) => {
      let id = params['id'] ? params['id'] : null;
      if (!id) {
        return this.router.navigate(['/data/measure']);
      } else {
        if (id === 'new') {
          this.item = new MeasureModel();
          this.fetchUnits();
        } else {
          this.fetchItem(id);
        }
      }
    })
  }

  fetchUnits() {
    this.unitService.getItems().subscribe((resp: any) => {
      this.units = resp.map(r => new UnitModel(r));
    })
  }

  fetchItem(id?) {
    this.service.getItem(id).subscribe((resp:any) => {
      if (resp.error) {
        this.service.notiService.open(resp.error);
        this.router.navigate(['/data/measure']);
      }
      if (resp.item) {
        this.item = new MeasureModel(resp.item);
      }
      if (resp.units) {
        this.units = resp.units.map(r => new UnitModel(r));
      }
    })
  }

  saveItem() {
    if (!this.item.isValid()) {
      return this.service.notiService.open("Fill every required fields");
    }
    this.service.saveItem(this.item).subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      this.service.notiService.open('Saved');
      this.router.navigate(['/data/measure']);
    })
  }

  onDeleteItemClick() {
    this.service.confirmAction().subscribe((isConfirm: boolean) => {
      if (isConfirm) {
        this.deleteItem();
      }
    })
  }

  deleteItem() {
    this.service.deleteItem(this.item.id).subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      this.service.notiService.open("Deleted");
      this.router.navigate(['/data/measure']);
    });
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 && o1.id && o2.id && +o1.id === +o2.id;
  }
}
